module.exports = __webpack_public_path__ + "img/Eleven_Tickets_Positivo_Vertical.d3285c79.svg";